import { render, staticRenderFns } from "./ComboBoxObject.vue?vue&type=template&id=8ca493ec&scoped=true&"
import script from "./ComboBoxObject.vue?vue&type=script&lang=ts&"
export * from "./ComboBoxObject.vue?vue&type=script&lang=ts&"
import style0 from "./ComboBoxObject.vue?vue&type=style&index=0&id=8ca493ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca493ec",
  null
  
)

export default component.exports